module.exports = __webpack_public_path__ + "static/media/Email.8dbd9e64.svg";